import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { DataEvent, DragStartEvent, DragEndEvent, DragOverEvent, NavigateEvent } from '@progress/kendo-angular-sortable';
import { Flow, onlyUnique } from '../obj/Flow';
import { FlowManagementService } from '../services/flow-management.service';
import { StorageRouterService } from '../services/storage-router.service';
import { SafeUrl, DomSanitizer } from '@angular/platform-browser';
import { Group } from '../obj/Group';
import { Settings } from '../flows/settings';
import { State, process } from '@progress/kendo-data-query';
import { GridDataResult } from '@progress/kendo-angular-grid';
// import { StorageService } from '../services/storage.service';

@Component({
    selector: 'app-success',
    templateUrl: './success.component.html',
    styleUrls: ['./success.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class SuccessComponent implements OnInit {

  // public colorsA: string[] = ['Violet', 'Magenta', 'Purple', 'SlateBlue'];
  // public colorsB: string[] = ['SteelBlue', 'CornflowerBlue', 'RoyalBlue', 'MediumBlue'];
  // public colorsC: string[] = ['LimeGreen', 'SeaGreen', 'Green', 'OliveDrab'];
  // public colorsD: string[] = ['LightSalmon', 'Salmon', 'IndianRed', 'FireBrick'];

  // public palettes: any[] = [
  //     { data: this.colorsA, name: 'Palette A' },
  //     { data: this.colorsB, name: 'Palette B' },
  //     { data: this.colorsC, name: 'Palette C' },
  //     { data: this.colorsD, name: 'Palette D' }
  // ];

  public flows: Flow[] = [];

  public _groups : { [key: string] : Group; } = {};
  public __groups : Group[] = [];

  ready = false;
  doPdf = false;

  display = "Grid";
  items = ['Tile', 'Grid'];
  // menu: any[] = [
  //   {
  //       text: 'Tile',
  //       icon: 'user'
  //   },
  //   {
  //       text: 'Grid',
  //       icon: 'aggregate-fields'
  //   }
  // ];

  state: State = {
      skip: 0,
      take: 50, //this.flows.length,

      // Initial filter descriptor
      filter: {
          logic: 'and',
          filters: [] //[{ field: 'ProductName', operator: 'contains', value: 'Chef' }]
      },
      sort: [
          {
              'field': 'displayName',
              'dir': 'asc'
          }
      ]
  };
  viewGroups: GridDataResult = process(this.__groups, this.state);

  constructor(
    private flowManagementService: FlowManagementService,
    // private storageService: StorageService,
    private storageDexieService: StorageRouterService,
    private sanitizer: DomSanitizer,
    private router: Router) {

  }

  ngOnInit() {

    this.ready = false;

    this.storageDexieService.putConfig(Settings.SETTING_LASTROUTE, {
      key: Settings.SETTING_LASTROUTE,
      'value': '/success'
    });

    let pEnvs = this.flowManagementService.getEnvironments().toPromise();

    pEnvs.then(res=>{

      let environments = res.value;

      let promises = [];

      environments.forEach(environment=> {

        let env = environment.name;
        //let env = this.flowManagementService.currentEnvironment;

        //let pCachedFlows = this.storageService.getFlows(env);
        let pCachedFlows = Promise.resolve([]);
        let pFlows = this.flowManagementService.getFlows(env, true, true).then(flows=>{
          let promises = [];
    
          flows.filter(flow=>{
    
            return flow.flowState == "Started";
    
          }).forEach(flow=>{
            flow.env = environment;
            let pRun = this.flowManagementService.getFlowRuns(flow, false, false, true).catch(res=>{ 
              flow.loading = false; 
              if (res.error && res.error.error && res.error.error.code == "FlowNotFound") {
                  flow.flowState = "Deleted";
              }
            });
            promises.push(pRun);
          })
          return Promise.all(promises).then(()=>{
            return flows;
          });
        });
        
        Promise.all([pCachedFlows, pFlows]).then( ([cachedFlows, flows])=>{
    
          let promises = [];
    
          flows.filter(flow=>{
    
            return flow.flowState == "Started";
    
          }).forEach(flow=>{
            // let pRun = this.flowManagementService.getFlowRuns(flow).catch(res=>{ 
            //   flow.loading = false; 
            //   if (res.error && res.error.error && res.error.error.code == "FlowNotFound") {
            //       flow.flowState = "Deleted";
            //   }
            // });
            // promises.push(pRun);
    
            let cacheFlow = cachedFlows.find(f=>f.flowName == flow.flowName);
    
            if (cacheFlow && cacheFlow.definition && cacheFlow.connections){
              flow.definition = cacheFlow.definition;
              flow.connections = cacheFlow.connections;
              //flow.env = flow.env;
              flow.env = environment;
            }
            else {
              let pFlow = this.flowManagementService.getFlow(flow.environment, flow.flowName).toPromise().then(res=>{
                //debugger
      
                flow.definition = res.properties.definition;
                flow.connections = Object.keys(res.properties.connectionReferences).map(connection=> res.properties.connectionReferences[connection]);
                flow.env = environment;
      
                // return this.storageService.updateFlow(flow);
      
              }).catch(reason=>{
      
                // flow not found?
      
              });
              promises.push(pFlow);  
            }
          });
    
    
          return Promise.all(promises).then(()=>{
            return flows;
          });
        });
    
        let pSolutionFlows = [];
    
        let pSolutions = this.flowManagementService.getSolutions(env).toPromise().then(solutions=> {
    
          solutions.forEach(solution=>{
    
            let pFlows = this.flowManagementService.getSolutionFlows(env, solution.solutionid).toPromise().then(flows=> {
    
              solution.flows = flows;
              return flows;
        
            });
    
            pSolutionFlows.push(pFlows);
      
          })
          return solutions;
    
        }, (reason)=> {
          return [];
        });
    
        let ppFlows = Promise.all(pSolutionFlows);
    
        let p = Promise.all([pFlows, pCachedFlows, pSolutions, ppFlows]).then(([flows, cachedFlows, solutions, solutionFlows])=>{
        //this.storageDexieService.getFlows(this.flowManagementService.currentEnvironment).then(flows=>{
    
          // let flows = value[0];
          // let solutions = value[1];
          //let sFlows = value[2];
    
          this.flows = flows;
    
          flows.forEach(flow=>{
    
            let solution = solutions.find(solution=>{
              return solution['flows'].find(f => f.msdyn_workflowidunique == flow.flowName) != null;
            })
    
            if (solution) {
              // debugger;
    
              let key = `${env}-${solution.friendlyname}`;
              // use solution name as grooup name.
              // add solution info to Flow
              this._groups[key] = (this._groups[key] || new Group(solution.friendlyname));
              this._groups[key].add(flow);
              this._groups[key].solution = solution;
    
              //debugger;
            }    
            else {

              ( flow.tags.length ? flow.tags : ["Unmanaged"]).forEach(tag => {

                let key = `${env}-${tag}`;
  
                this._groups[key] = (this._groups[key] || new Group(tag));
                this._groups[key].add(flow);
              });
        
            }
          });    
        });
    
        promises.push(p);

      });

      Promise.all(promises).then(()=>{
        Object.keys(this._groups).forEach(tag => {
    
          let group = this._groups[tag];
  
          group.organize();
        });
  
        this.__groups = Object.keys(this._groups).sort((a,b)=>{
  
          if (this._groups[a].name == "Unmanaged"){
            return 1;
          }
          if (this._groups[b].name == "Unmanaged"){
            return -1;
          }
          if (this._groups[b].solution && this._groups[a].solution == null) {
            return 1;
          }
          if (this._groups[a].solution && this._groups[b].solution == null) {
            return -1;
          }
    
          let _a = this._groups[a].tFails;
          let _b = this._groups[b].tFails;
          if (_a == _b) {
            _a = this._groups[a].tEstimates;
            _b = this._groups[b].tEstimates;
          }
          if (_a == _b) {
            _a = this._groups[a].tRuns;
            _b = this._groups[b].tRuns;
          }
          return _b-_a;
        }).map(tag => {
          return this._groups[tag]
        });
  
        //this.viewGroups = process(this.__groups, this.state);
  
        this.ready = true;  
      });
    });
  }

  get groups() {

    return this.__groups;

    // return Object.keys(this._groups).sort().map(tag => {
    //   return { name: tag, data: this._groups[tag] }
    // });
  }

  getSafeUrl(url): SafeUrl {
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }

  public async doGetRuns(flow: Flow) {
    if (!flow?.environment || !flow?.flowName) return;
    this.router.navigate(['/flows', flow.environment, flow.flowName, 'runs']);
  }

  public loadMore(group:Group) {




  }

  public onSelect({ item }): void {
    this.display = item.text;
  }

  public onDoPdf(pdf) {
    this.doPdf = true;
    pdf.saveAs('flow-inventory.pdf')
    this.doPdf = false;
  }

}
